import React from 'react'
import { Container } from 'react-bootstrap'

const Credits = () => {
  return <Container fluid className='bg-light'>
    <h1>Credits</h1>    
    <ul>
      <li>Realizzato da G&F Software S.r.l<br />via del fontanile arenato 171b 00163 Roma</li>
      
      <li><a href="https://www.freepik.com/free-vector/man-signing-contract-with-big-pen_11235712.htm#fromView=image_search_similar&page=2&position=5&uuid=78d80235-9c62-4bda-9559-0285795556ec&query=iscrizione+albo" target="_blank" rel="noreferrer">Icon by pch.vector</a></li>            
      <li><a href="https://www.flaticon.com/free-icons/append" title="append icons" target="_blank" rel="noreferrer">Append icons created by hqrloveq - Flaticon</a></li>
      <li><a href="https://www.freepik.com/icon/info_8371206#fromView=search&page=2&position=9&uuid=fd9d8f83-72e6-4d55-8b6b-0b581710f288">Icon by Anggara</a></li>
      <li><a href="https://www.flaticon.com/free-icons/file" title="file icons" target="_blank" rel="noreferrer">File icons created by Freepik - Flaticon</a></li>
    </ul>        
  </Container>
}

export default Credits